import React from 'react';

//import OtchetSection from './OtchetSection'; // Import the new parent component

function Footer() {


  return (
    <>
      <footer className="bg-teal-800 text-white py-8">
        <div className="flex justify-center mx-auto px-6 text-center space-x-4 ">
          <p className="mb-4">© 2025 Sovtechexport</p>
          <a href="/otchety/2024.pdf" className="mb-4 underline">Отчеты</a>
  
        </div>
      </footer>

    </>
  );
}

export default Footer;